var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{staticClass:"flex-1",attrs:{"name":"fade-transform","mode":"out-in"}},[_c('router-view',{staticClass:"flex-1"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }